import React from 'react';
import Dropdown from "../../components/Dropdown";

const BoolFilter = ({filter, column, setFilter}) => {

    const options = [
        {
            value: '1',
            key: '1',
            text: 'Да'
        },
        {
            value: '0',
            key: '0',
            text: 'Нет'
        }
    ];

    const changeFilter = (v) => {
        setFilter({
            fieldName: column.fieldName,
            operation: 'equals',
            value: v
        });
    }

    return (
        <Dropdown
            className={!column.disableSort ? 'filter-with-sort' : ''}
            clearable
            name={column.fieldName}
            placeholder={column.title}
            selectOnNavigation={false}
            selectOnBlur={false}
            compact
            options={options}
            value={(filter || {}).value || null}
            onChange={(e, {value}) => changeFilter(value)}
        />
    );
};

export default BoolFilter;


// WEBPACK FOOTER //
// ./App/grids/filters/bool.jsx